import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import PerText from '../Text'
import PerFlexRow from '../FlexRow'
import { Card, Checkbox } from 'antd'

interface CreateKudosModalGuidelinesProps {
  setGuidelinesAccepted: (accepted: boolean) => void
  guidelinesAccepted: boolean
}

export const CreateKudosModalGuidelines: FC<CreateKudosModalGuidelinesProps> = ({ guidelinesAccepted, setGuidelinesAccepted }) => {
  const { t } = useTranslation()

  return (
    <PerFlexRow direction="column" mt="xxl">
      <Card>
        <PerText fontSize="m" fontWeight="bold" mb="xxs">
          {t('kudos.createModal.guidelines.header')}
        </PerText>
        <PerText fontSize="m">{t('kudos.createModal.guidelines.description1')}</PerText>
        <PerText fontSize="m" mb="xs">
          {t('kudos.createModal.guidelines.description2')}
        </PerText>

        <PerFlexRow align="middle">
          <Checkbox checked={guidelinesAccepted} onChange={(checked) => setGuidelinesAccepted(checked.target.checked)} />
          <PerText fontSize="m" color="secondary" ml="xs">
            {t('kudos.createModal.guidelines.checkboxLabel')}
          </PerText>
        </PerFlexRow>
      </Card>{' '}
    </PerFlexRow>
  )
}

export default CreateKudosModalGuidelines
